import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: 'AIzaSyCS2Z57SzLr1BhLzXbuj2QVs_YwkfTrkYc',
  authDomain: 'prefeitura-anastacio-ms.firebaseapp.com',
  databaseURL: 'https://prefeitura-anastacio-ms-default-rtdb.firebaseio.com',
  projectId: 'prefeitura-anastacio-ms',
  storageBucket: 'prefeitura-anastacio-ms.firebasestorage.app',
  messagingSenderId: '985127121259',
  appId: '1:985127121259:web:5f8b672baeb657c5af9c2e',
  measurementId: 'G-618XR5KVBX',
};

const app = initializeApp(firebaseConfig);

export const db = getDatabase(app);
export default app;
